import { FC, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { pipe } from 'fp-ts/function';
import { FormHiddenInput, FormRadioGroupField, lt, useLocalizeEnum } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { PromotedServiceAssignmentReservationIntervalLimit, Service } from '@mews-commander/data-access';
import { ServiceTimeClass } from '@mews/enums';
import { RadioButton } from '@optimus-web/core';
import { getTimeClass } from '@mews-commander/utils';
import { FormFields, FormValues } from '../../../schema';

interface IntervalLimitFieldProps {
    selectedService: Service;
}

export const IntervalLimitField: FC<IntervalLimitFieldProps> = ({ selectedService }) => {
    const le = useLocalizeEnum();
    const { setValue } = useFormContext<FormValues>();
    const serviceTimeUnit = pipe(selectedService, getTimeClass);

    const isSelectedServiceTimePeriodHourly = serviceTimeUnit === ServiceTimeClass.Hour;

    useEffect(() => {
        if (isSelectedServiceTimePeriodHourly) {
            setValue(
                FormFields.ReservationIntervalLimit,
                PromotedServiceAssignmentReservationIntervalLimit.InsideParent
            );
        }
    }, [isSelectedServiceTimePeriodHourly, setValue]);

    return isSelectedServiceTimePeriodHourly ? (
        <FormHiddenInput name={FormFields.ReservationIntervalLimit} />
    ) : (
        <FormRadioGroupField
            name={FormFields.ReservationIntervalLimit}
            required
            label={lt(TextKey.PromotedServiceAssignmentReservationIntervalLimit)}
        >
            {Object.values(PromotedServiceAssignmentReservationIntervalLimit).map((interval) => (
                <RadioButton
                    label={le('PromotedServiceAssignmentReservationIntervalLimit', interval)}
                    value={interval}
                    key={interval}
                />
            ))}
        </FormRadioGroupField>
    );
};
